module.exports = __webpack_public_path__ + "img/team-empty-state.a3fe19da.svg";